import { CategoriaDoMixDoCliente, TopPecaDoCliente } from '../models/PainelDoCliente'
import { TEXTO_SEM_DADOS, valorOuSemDados } from './painel-do-cliente-shareds'

export const LIMITE_DE_ITENS_NO_BLOCO = 3

export interface ResumoDoMix {
	principais: CategoriaDoMixDoCliente[]
	rodape: string | null
}

export function textoDePecas(pecas: number): string {
	return `${pecas} ${pecas === 1 ? 'peça' : 'peças'}`
}

export function textoDoPercentualDoMix(percentual: number, pecas: number): string {
	return pecas > 0 && percentual < 1 ? '<1%' : `${percentual}%`
}

export function textoDaParticipacaoNoMix(categoria: CategoriaDoMixDoCliente): string {
	return `${textoDoPercentualDoMix(categoria.pct, categoria.pecas)} · ${textoDePecas(categoria.pecas)}`
}

export function ordenarMixDeCategorias(categorias: CategoriaDoMixDoCliente[] | null | undefined): CategoriaDoMixDoCliente[] {
	return [...(categorias || [])].sort((a, b) => b.pecas - a.pecas)
}

export function ordenarTopPecas(topPecas: TopPecaDoCliente[] | null | undefined): TopPecaDoCliente[] {
	return [...(topPecas || [])].sort((a, b) => b.vezes - a.vezes)
}

export function textoDoRodapeDoMix(restantes: CategoriaDoMixDoCliente[], totalDePecas: number): string | null {
	if (!restantes.length) return null

	const outras = restantes.length === 1 ? '+1 outra categoria' : `+${restantes.length} outras categorias`
	const pecas = restantes.reduce((soma, categoria) => soma + categoria.pecas, 0)
	const percentual = totalDePecas > 0 ? Math.round(100 * pecas / totalDePecas) : 0

	return `${outras} · ${textoDoPercentualDoMix(percentual, pecas)} · ${textoDePecas(pecas)}`
}

export function resumirMix(
	categorias: CategoriaDoMixDoCliente[] | null | undefined,
	limite: number = LIMITE_DE_ITENS_NO_BLOCO,
): ResumoDoMix {
	const ordenadas = ordenarMixDeCategorias(categorias)
	const totalDePecas = ordenadas.reduce((soma, categoria) => soma + categoria.pecas, 0)

	return {
		principais: ordenadas.slice(0, limite),
		rodape: textoDoRodapeDoMix(ordenadas.slice(limite), totalDePecas),
	}
}

export function resumirTopPecas(
	topPecas: TopPecaDoCliente[] | null | undefined,
	limite: number = LIMITE_DE_ITENS_NO_BLOCO,
): TopPecaDoCliente[] {
	return ordenarTopPecas(topPecas).slice(0, limite)
}

export function deveMostrarVerMais(
	categorias: CategoriaDoMixDoCliente[] | null | undefined,
	topPecas: TopPecaDoCliente[] | null | undefined,
	limite: number = LIMITE_DE_ITENS_NO_BLOCO,
): boolean {
	return (categorias || []).length > limite || (topPecas || []).length > limite
}

export function nomeDaCategoriaDoMix(categoria: CategoriaDoMixDoCliente): string {
	return valorOuSemDados(categoria.categoria)
}

export function nomeDaPeca(peca: TopPecaDoCliente): string {
	const nome = valorOuSemDados(peca.peca)
	return nome === TEXTO_SEM_DADOS ? nome : nome.toUpperCase()
}

export function textoDosSkus(peca: TopPecaDoCliente): string {
	return `SKU ${valorOuSemDados(peca.skuItem)} · Ref ${valorOuSemDados(peca.skuPai)}`
}

export function textoDasVezes(peca: TopPecaDoCliente): string {
	return `${peca.vezes}x`
}
